var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Grid from '@lendi-ui/grid';
import { useSession } from '@lendi/lala-react';
import React, { useEffect, useState } from 'react';
import { Form } from 'react-final-form';
import { analytics, ChatEventName, EventCategory } from '../../../analytics';
import { useBootstrappedChatState } from '../../../providers/ChatBootstrapperProvider';
import { useError } from '../../../providers/ErrorProvider/context';
import { formatInitialPhoneNumber } from '../../../utils';
import { sendLeads } from '../../../utils/sendLeads';
import { trimPhoneNumber, validateInput } from '../../../utils/validateInput';
import { LoadingButton } from '../atoms/LoadingButton';
import { EmailField, FirstNameField, MobileField } from '../FieldComponents';
import { AuthTypes, SmartChatTypes } from '../SmartChat/states';
import { SmartExperimentCheckpoint } from '../SmartChat/states/state/types';
import { Margin, Wrapper } from './style';
import { handleAuthError } from '../../../utils/authError';
import { Devider, Heading } from '../SmartChatExperiment1/style';
export var SignIn = function (_a) {
    var chatState = _a.chatState, chatDispatch = _a.chatDispatch, authState = _a.authState, authDispatch = _a.authDispatch, showEmail = _a.showEmail, experiment1 = _a.experiment1;
    var _b = useBootstrappedChatState(), chatInputFields = _b.chatInputFields, setChatInputFields = _b.setChatInputFields;
    var _c = useSession(), environment = _c.environment, brand = _c.brand, sendCode = _c.sendCode;
    var onException = useError().onException;
    var _d = useState(false), isLoading = _d[0], setIsLoading = _d[1];
    var _e = useState(false), submitted = _e[0], setSubmitted = _e[1];
    var phoneNumber = chatState.phoneNumber, firstName = chatState.firstName, _f = chatState.email, email = _f === void 0 ? '' : _f;
    var error = authState.error;
    var resetAuthError = function () {
        authDispatch({ type: AuthTypes.ERROR, payload: null });
    };
    var onSubmit = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var firstName, phoneNumber, email, phone, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    firstName = values.firstName, phoneNumber = values.phoneNumber, email = values.email;
                    phone = "+61".concat(trimPhoneNumber(phoneNumber));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    chatDispatch({ type: SmartChatTypes.UPDATE_FIRST_NAME, payload: firstName });
                    chatDispatch({ type: SmartChatTypes.UPDATE_PHONE_NUMBER, payload: phone });
                    showEmail && chatDispatch({ type: SmartChatTypes.UPDATE_EMAIL, payload: email });
                    authDispatch({ type: AuthTypes.SEND_CODE });
                    return [4 /*yield*/, sendCode(phone)];
                case 2:
                    _a.sent();
                    authDispatch({ type: AuthTypes.SENT_CODE });
                    chatDispatch({
                        type: SmartChatTypes.NEXT_EXPERIMENT_ONE_SMART_STATE,
                        payload: SmartExperimentCheckpoint.ON_VERIFY_CHECK,
                    });
                    chatDispatch({ type: SmartChatTypes.SIGN_IN_SUBMITTED, payload: true });
                    sendLeads({
                        phoneNumber: phoneNumber,
                        email: email,
                        firstName: firstName,
                        chatDispatch: chatDispatch,
                        environment: environment,
                        brand: brand,
                        onException: onException,
                    });
                    analytics({
                        event_name: ChatEventName.SUBMIT_FORM_CLICKED,
                        category: EventCategory.CHAT,
                    });
                    setSubmitted(true);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    handleAuthError({ error: error_1, authDispatch: authDispatch, onException: onException });
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var trackEvent = function (event, value) {
            if (value) {
                analytics({
                    event_name: event,
                    category: EventCategory.CHAT,
                });
            }
        };
        trackEvent(ChatEventName.PHONE_NUMBER_ENTERED, phoneNumber);
        showEmail && trackEvent(ChatEventName.EMAIL_ENTERED, email);
        trackEvent(ChatEventName.FIRST_NAME_ENTERED, firstName);
    }, [phoneNumber, email, firstName]);
    var onInputChange = function (e) {
        var _a = e.target || {}, name = _a.name, value = _a.value;
        setChatInputFields(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[name] = value, _a)));
        });
    };
    return (React.createElement(Wrapper, { experiment1: experiment1 },
        !experiment1 && (React.createElement(React.Fragment, null,
            React.createElement(Devider, { hasMargin: true }),
            React.createElement(Heading, null, "Enter your details before we get started."))),
        React.createElement(Grid, { halign: "center" },
            React.createElement(Grid.Unit, { size: 1 },
                React.createElement(Form, { initialValues: {
                        phoneNumber: formatInitialPhoneNumber(phoneNumber || (chatInputFields === null || chatInputFields === void 0 ? void 0 : chatInputFields.phoneNumber) || ''),
                        firstName: firstName || (chatInputFields === null || chatInputFields === void 0 ? void 0 : chatInputFields.firstName),
                        email: email || (chatInputFields === null || chatInputFields === void 0 ? void 0 : chatInputFields.email) || '',
                    }, validate: function (values) { return validateInput(values, showEmail); }, onSubmit: onSubmit }, function (_a) {
                    var handleSubmit = _a.handleSubmit, invalid = _a.invalid;
                    return (React.createElement("form", { style: { textAlign: 'center' }, onSubmit: handleSubmit },
                        React.createElement(FirstNameField, { autoFocus: true, labelText: "First Name", error: error, resetAuthError: resetAuthError, onInputChange: onInputChange, isDisabled: submitted }),
                        React.createElement(MobileField, { error: error, resetAuthError: resetAuthError, labelText: "Mobile number", onInputChange: onInputChange, isDisabled: submitted }),
                        showEmail && (React.createElement(EmailField, { error: error, resetAuthError: resetAuthError, label: "Email", isDisabled: submitted, onInputChange: onInputChange })),
                        React.createElement(LoadingButton, { type: "submit", mt: "xxs", variant: "primary", "data-testid": "sign-in", isDisabled: invalid || submitted, loading: isLoading, isFullWidth: true }, 'SUBMIT')));
                }))),
        !experiment1 && (React.createElement(Margin, null,
            React.createElement(Devider, { hasMargin: true })))));
};
//# sourceMappingURL=index.js.map